import React from "react";
import Card from "components/card";
import { Recipe } from "../../types/recipe";
import { getMealTypeLabel, getMealTypeColor } from "../../utils/recipeUtils";

interface RecipeInfoCardProps {
  recipe: Recipe;
}

const RecipeInfoCard: React.FC<RecipeInfoCardProps> = ({ recipe }) => {
  return (
    <Card extra="w-full p-3 md:p-6">
      <h2 className="mb-6 text-xl font-bold text-navy-700 dark:text-white">
        Recipe Information
      </h2>

      <div className="grid grid-cols-1 gap-6 text-sm md:grid-cols-2">
        <div className="flex items-center justify-between border-b border-gray-200 py-2 dark:border-gray-700">
          <span className="font-medium text-gray-600 dark:text-gray-400">
            Recipe ID:
          </span>
          <span className="text-navy-700 dark:text-white">#{recipe.id}</span>
        </div>

        <div className="flex items-center justify-between border-b border-gray-200 py-2 dark:border-gray-700">
          <span className="font-medium text-gray-600 dark:text-gray-400">
            Meal Type:
          </span>
          <span
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${getMealTypeColor()}`}
          >
            {getMealTypeLabel(recipe.meal_type)}
          </span>
        </div>

        <div className="flex items-center justify-between border-b border-gray-200 py-2 dark:border-gray-700">
          <span className="font-medium text-gray-600 dark:text-gray-400">
            Created:
          </span>
          <span className="text-navy-700 dark:text-white">
            {new Date(recipe.created_at).toLocaleDateString()}
          </span>
        </div>

        <div className="flex items-center justify-between border-b border-gray-200 py-2 dark:border-gray-700">
          <span className="font-medium text-gray-600 dark:text-gray-400">
            Last Updated:
          </span>
          <span className="text-navy-700 dark:text-white">
            {new Date(recipe.updated_at).toLocaleDateString()}
          </span>
        </div>

        <div className="flex items-center justify-between border-b border-gray-200 py-2 dark:border-gray-700">
          <span className="font-medium text-gray-600 dark:text-gray-400">
            Ingredients:
          </span>
          <span className="text-navy-700 dark:text-white">
            {recipe.components?.length ?? 0}
          </span>
        </div>
      </div>
    </Card>
  );
};

export default RecipeInfoCard;
